/**
 * Pure helpers of `OrganizerSidePanel` (mock `.panel`, 460 px; modal with a blurred scrim at every
 * width since William's decision of 19 Oct 2026).
 */
export const SIDE_PANEL_WIDTH = 460

/** A key event inside a field must not be stolen by the panel (Escape excepted, which always closes). */
export const isTypingElement = (element) =>
    !!element && (/^(INPUT|SELECT|TEXTAREA)$/.test(element.tagName || '') || element.isContentEditable === true)

/** Right padding that replaces the scrollbar while the body scroll is locked (mock `openScore`). */
export const scrollbarGap = (innerWidth, clientWidth) => Math.max(0, (innerWidth || 0) - (clientWidth || 0))

/**
 * What a key press means for the panel: 'close' on Escape (anywhere), 'submit' on Enter outside a
 * textarea / button when `submitOnEnter` is set, null otherwise.
 */
export const panelKeyIntent = ({ key, target, submitOnEnter = false, shiftKey = false }) => {
    if (key === 'Escape') return 'close'
    if (key !== 'Enter' || !submitOnEnter || shiftKey) return null
    const tag = target?.tagName || ''
    if (tag === 'TEXTAREA' || tag === 'BUTTON' || tag === 'A') return null
    return 'submit'
}
